<template>
  <div class="pdf-zoom">
    <a @click.prevent.stop="zoomIn" class="icon" :disabled="isDisabled"><span class="icon-zoom-in"></span></a>
    <a @click.prevent.stop="zoomOut" class="icon" :disabled="isDisabled"><span class="icon-zoom-out"></span></a>
    <a @click.prevent.stop="fitWidth" class="icon" :disabled="isDisabled"><span class="icon-expand"></span></a>
    <a @click.prevent.stop="fitAuto" class="icon" :disabled="isDisabled"><span class="icon-shrink"></span></a>
  </div>
</template>

<script>
export default {
  name: 'PDFZoom',
  props: {
    scale: {
      type: Number
    },
    increment: {
      type: Number,
      default: 0.25
    }
  },

  computed: {
    isDisabled () {
      return !this.scale
    }
  },

  methods: {
    zoomIn () {
      this.updateScale(this.scale + this.increment)
    },

    zoomOut () {
      if (this.scale <= this.increment) return
      this.updateScale(this.scale - this.increment)
    },

    updateScale (scale) {
      this.$emit('change', { scale })
    },

    fitWidth () {
      this.$emit('fit', 'width')
    },

    fitAuto () {
      this.$emit('fit', 'auto')
    }
  }
}
</script>

<style>
.pdf-zoom a {
  float: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  margin-right: 7px;
  background-color: var(--primary-400);
  color: var(--primary-700);
  font-weight: bold;
  line-height: 1.5em;
  width: 1.5em;
  height: 1.5em;
  font-size: 1.5em;
}
.pdf-zoom a:hover {
  background-color: rgba(166, 178, 196, 0.5);
  color: var(--light);
}
</style>
